import React, { useCallback } from "react";

import Screen from "./ConnectedScreen";
import ListItem from "../components/ListItem";

function RegionScreen({ regionId, regions, setRegion, onBack, goTo }) {
  const goToCity = useCallback(() => goTo("city"));

  return (
    <Screen
      {...{
        title: "Meet escort in...",
        isActive: true,
        onNext: goToCity,
        nextDisabled: !regionId,
        onBack,
      }}
    >
      {regions.map(({ id, name, disabled }) => (
        <ListItem
          {...{
            key: id,
            id,
            title: name,
            active: regionId === id,
            disabled,
            onPress: setRegion,
          }}
        />
      ))}
    </Screen>
  );
}

import { connect } from "react-redux";
import { bindActionCreators as bindActions } from "redux";

import { intlRegionAction } from "../modules/intl";
import { goToScreen } from "../modules/modal";
import { getRegions } from "../selectors";

const state = (state) => ({
  regionId: state.intl.regionId,
  regions: getRegions(state),
  onBack: false,
});

const actions = (dispatch) =>
  bindActions(
    {
      setRegion: intlRegionAction,
      goTo: goToScreen,
    },
    dispatch
  );

export default connect(state, actions)(RegionScreen);
